import React, { Component } from 'react';
import { Link } from "react-router-dom";
import {
    Row,
    Col,
    Card,
    Icon,
    Table,
    Button,
    Popconfirm,
    message
} from 'antd';
import moment from 'moment';
import F from '../../Functions';
import axios from 'axios';
import { Translate } from 'react-translated';
import Cookies from 'js-cookie';
import CustomAgGridTable from '../../Common-Table/CustomAgGridTable';
import '../../Common-Table/CustomAgGridTable.css';
import CustomHeader from '../../CommonHeader/CustomHeader';

class InvitedUsers extends Component {
    state = {
        loading: true,
        users: [],
        user: {}
    }
    componentDidMount = () => {
        this.loadUsers(1);
    }
    componentDidUpdate = (prevProps) => {
        if (prevProps.location.state !== this.props.location.state) {
            this.loadUsers(1)
        }
    };
    loadUsers = (page) => {
        const users_list = [];
        const historyState = this.props.history.location;
        let user = JSON.parse(Cookies.get('user_info'));

        let api = (user.user_type == 'SUPER_ADMIN') ? '/api/invited_users_sa' : `/api/invited_users${user.user_type === 'SUPER_ADMIN' && `?user_type=${historyState.state.user_type}` || ''}`;

        this.setState({ loading: true });

        axios.get(api).then((res) => {
            const users = res.data.results;
            this.setState({ loading: false, users: Array.isArray(users) ? users : [] });
        });
    }
    resend = (id, email) => {
        this.setState({ loading: true });
        axios.get("/api/reinvite/" + id).then(() => {
            this.setState({ loading: false });
            message.success("Your invitation request has been successfully sent to " + email);
        }).catch(() => {
            this.setState({ loading: false });
            message.error(F.translate(`Invite not sent.`));
        });
    }
    delete = (id) => {
        this.setState({ loading: true });
        axios.put("/api/users/" + id, {
            registration_token: null
        }).then(() => {
            message.success(F.translate(`The invitation request has been removed.`));
            this.setState({ loading: false }, () => {
                this.loadUsers(1);
            });
        }).catch(() => {
            this.setState({ loading: false });
            message.error(F.translate(`Invite not removed.`));
        });
    }


    onGridReady = (params) => {
        this.setState({
            gridApi: params.api,
            columnApi: params.columnApi
        });

        const savedState = localStorage.getItem("agGridColumnState");
        if (savedState) {
            params.columnApi.applyColumnState({
                state: JSON.parse(savedState),
                applyOrder: true,
            });
        }
    }

    saveState = (params) => {
        const state = params.columnApi.getColumnState();
        localStorage.setItem("agGridColumnState", JSON.stringify(state));
    }


    render() {

        const { loading, users } = this.state;

        // Define AgGrid column definitions
        const columnDefs = [
            {
                headerClass: 'custom-ag-header',
                headerName: "First Name",
                field: 'first_name',
                minWidth: 150,
                flex: 1,
                sortable: false,
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ['First Name'],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: 'first_name',
                }),
                cellRendererFramework: (params) => (
                    <div>{params.data.first_name}</div>
                ),
            },
            {
                headerClass: 'custom-ag-header',
                headerName: "Last Name",
                field: 'last_name',
                minWidth: 150,
                flex: 1,
                sortable: false,
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ['Last Name'],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: 'last_name',
                }),
                cellRendererFramework: (params) => (
                    <div>{params.data.last_name}</div>
                ),
            },
            {
                headerClass: 'custom-ag-header',
                headerName: "Email",
                field: 'email',
                minWidth: 200,
                flex: 1,
                sortable: false,
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ['Email'],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: 'email',
                }),
                cellRendererFramework: (params) => (
                    <div>{params.data.email}</div>
                ),
            },
            {
                headerClass: 'custom-ag-header',
                headerName: "Actions",
                field: 'action',
                minWidth: 250,
                flex: 1,
                sortable: false,
                headerComponent: CustomHeader,
                headerComponentParams: (params) => ({
                    headers: ['Actions'],
                    colDef: params.column.getColDef(),
                    columnApi: params.columnApi,
                    field: 'action',
                }),
                cellRendererFramework: (params) => (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%', height: '100%' }}>
                        <Button
                            className="borderRadius-28"
                            onClick={() => this.resend(params.data.id, params.data.email)}><Icon type="mail" /> <Translate text={`Resend`} /></Button>
                        <Popconfirm placement="topRight" title={<Translate text={`Do you really want to delete this invite?`} />}
                            onConfirm={() => this.delete(params.data.id)}
                            okText={<Translate text={`Yes`} />}
                            cancelText={<Translate text={`No`} />}
                            okButtonProps={{ className: 'borderRadius-28 bg-164897' }}
                            cancelButtonProps={{ className: 'borderRadius-28' }}
                            getPopupContainer={(triggerNode) => {
                                let node = triggerNode;
                                while (node && node !== document.body) {
                                    if (node.classList && node.classList.contains('ant-card-body')) {
                                        return node;
                                    }
                                    node = node.parentNode;
                                }
                                return document.body;
                            }}
                        >
                            <Button style={{ marginLeft: 10 }} type="danger" className="borderRadius-28" ghost>
                                <Icon type="delete" /> <Translate text={`Delete`} />
                            </Button>
                        </Popconfirm>
                    </div>
                ),
            },
        ];

        const data = [];
        for (let i = 0; i < users.length; i++) {
            let user = users[i];

            data.push({
                key: i,
                id: user.id,
                first_name: user.first_name,
                last_name: user.last_name,
                email: user.email,
            });
        }

        return (
            <div>
                <Card
                    type="inner"
                    title={
                        <div style={{ paddingTop: 7 }}>
                            <Icon type="team" style={{ marginRight: 10, color: "#1890ff" }} />
                            <Translate text={`Invited Users`} />
                        </div>
                    }
                    className="tableCard"
                    loading={loading}
                >
                    <CustomAgGridTable
                        onGridReady={this.onGridReady}
                        onColumnMoved={this.saveState}
                        onSortChanged={this.saveState}
                        onFilterChanged={this.saveState}
                        rowDatas={data}
                        columnDefss={columnDefs}
                    />
                </Card>
            </div>
        );

    }
}

export default InvitedUsers;



// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/invited-users.js